import '../styles/layout/_footer.scss';

export default function Footer() {
    return <footer>I am a Footer</footer>;
}